import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { faDollarSign } from '@fortawesome/pro-regular-svg-icons';
import SyfDisputes, { DisputeFeature } from 'digital-disputes';
import isNil from 'lodash/isNil';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useMerchantInfoQuery } from 'syf-api/merchantInfo';
import { RenderIf } from 'syf-component-library/ui/atoms';
import SlideInModalLoader from 'syf-component-library/ui/atoms/Loader/Skeleton/SlideInModalLoader';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { getDisputesConfig } from '../../../../const/activity-config';
import { isCanceledPaymentTransaction, isNoErrorPurchaseOrCanceledPayment, isNotCanceledTransaction, triggerAnalyticsEvent } from '../../../../helpers';
import { previouslyVisited } from '../../../../helpers/utils/activity-utils';
import { validateAmount } from '../../../../helpers/utils/amount-utils';
import useTransaction from '../../../../hooks/use-transaction';
import TransactionDetail from '../../../common/transaction-detail';
import CanceledPaymentTransactionDetails from '../../cancel-payment/transaction-detail';
import Enrichment from '../../enrichment';
import NotCancelTransactionDetails from '../../not-cancel-transaction';
var ExtraInfoDetails = function (_a) {
    var accountId = _a.accountId, config = _a.config, currentTransaction = _a.currentTransaction, type = _a.type;
    var status = currentTransaction.status, description = currentTransaction.description;
    var merchantId = description ? description.replaceAll(' ', '') : '';
    var emptyDescription = isNil(merchantId);
    var displayedTransactionAmount = validateAmount(currentTransaction.amount);
    var t = useTranslation().t;
    var enableMerchantInfoQuery = type === 'PURCHASE' && !emptyDescription;
    var _b = useMerchantInfoQuery({
        config: config,
        keyProps: {
            merchantId: merchantId
        },
        queryOptions: {
            enabled: enableMerchantInfoQuery,
            retry: false
        }
    }), merchantInfo = _b.data, isError = _b.isError, isFetching = _b.isFetching;
    var _c = useTransaction(), changeModal = _c.changeModal, closeModal = _c.closeModal, disputesEnabled = _c.disputesEnabled, disputesLinkEnabled = _c.disputesLinkEnabled, transactionDetails = _c.transactionDetails, handleNavigate = _c.handleNavigate;
    var launchDisputes = function (flow) {
        if (flow === DisputeFeature.Questionnaire) {
            closeModal();
            changeModal(true);
        }
        if (flow === DisputeFeature.DisputeCenter) {
            closeModal();
            if (disputesLinkEnabled) {
                handleNavigate === null || handleNavigate === void 0 ? void 0 : handleNavigate('disputes');
            }
        }
    };
    useEffect(function () {
        triggerAnalyticsEvent({
            pageKind: 'activity',
            pageFunction: 'transaction_enrichment',
            pageSubFunction: 'popup',
            message: "".concat(type),
            pageName: 'view',
            previouslyVisited: "".concat(previouslyVisited)
        });
    }, [type]);
    if (!Object.keys(currentTransaction).length)
        return _jsx("div", { children: "No transaction data" });
    if (isFetching) {
        return (_jsx(Inset, { all: "large", children: _jsx(SlideInModalLoader, {}) }));
    }
    return (_jsxs(_Fragment, { children: [_jsxs("dl", { children: [_jsx(TransactionDetail, { title: "amount", icon: faDollarSign, heading: t('activityDetails.amountLabel'), detail: displayedTransactionAmount }), _jsx(RenderIf, { condition: isNotCanceledTransaction(status), children: _jsx(NotCancelTransactionDetails, { emptyDescription: true, unsuccessfulEnrichmentRequest: isError, currentTransaction: currentTransaction, type: type }) }), _jsx(RenderIf, { condition: isCanceledPaymentTransaction(status, type), children: _jsx(CanceledPaymentTransactionDetails, { currentTransaction: currentTransaction, type: type }) })] }), _jsx(RenderIf, { condition: isNoErrorPurchaseOrCanceledPayment({
                    status: status,
                    type: type,
                    emptyDescription: emptyDescription,
                    isError: isError
                }), children: _jsx(Enrichment, { merchantInfo: merchantInfo, currentTransaction: currentTransaction, type: currentTransaction.type }) }), _jsx(RenderIf, { condition: disputesEnabled && status === 'POSTED', children: _jsx(SyfDisputes, { accountId: accountId, disputesMFEConfig: getDisputesConfig(config), feature: DisputeFeature.Eligibility, transaction: transactionDetails, returnToParent: launchDisputes }) })] }));
};
export default ExtraInfoDetails;
//# sourceMappingURL=index.js.map